// Firmalar, abonelik, planlar, bayraklar, maliyet, beyaz etiket ve genel bakış (A01–A06, A09, A17).
import { Route } from 'react-router';
import { guard, load } from '../../route-utils';

const Overview = load(() => import('./Overview'), 'Overview');
const CompanyList = load(() => import('./companies/CompanyList'), 'CompanyList');
const CompanyDetail = load(() => import('./companies/CompanyDetail'), 'CompanyDetail');
const Subscriptions = load(() => import('./billing/Subscriptions'), 'Subscriptions');
const Plans = load(() => import('./billing/Plans'), 'Plans');
const FeatureFlags = load(() => import('./FeatureFlags'), 'FeatureFlags');
const Costs = load(() => import('./usage/Costs'), 'Costs');
const WhiteLabel = load(() => import('./system/WhiteLabel'), 'WhiteLabel');

export const adminBusinessRoutes = (
  <>
    <Route index element={guard(Overview, 'platform')} />
    <Route path="firmalar" element={guard(CompanyList, 'companies')} />
    <Route path="firmalar/:id" element={guard(CompanyDetail, 'companies')} />
    <Route path="abonelikler" element={guard(Subscriptions, 'subscriptions')} />
    <Route path="planlar" element={guard(Plans, 'subscriptions')} />
    <Route path="moduller" element={guard(FeatureFlags, 'companies')} />
    <Route path="kullanim/maliyetler" element={guard(Costs, 'platform')} />
    <Route path="beyaz-etiket" element={guard(WhiteLabel, 'companies')} />
  </>
);
